import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from '../../app.service';
import { messageService } from '../../message.service';
import { PaginationService } from '../../PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditorComponent } from '../../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-dynamic-audit-trail',
  templateUrl: './dynamic-audit-trail.component.html',
  styleUrls: ['./dynamic-audit-trail.component.scss']
})

export class DynamicAuditTrailComponent implements OnInit {

  key: any;
  noData: boolean = false;
  reportObj: any = {};

  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  pdfDetailSearchText: string = '';
  constructor(private appService: AppService, public paginationService: PaginationService, public message: messageService, private elem: ElementRef, public dialog: MatDialog, private snackBar: MatSnackBar) {

  }

  ngOnInit(): void {
    this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
  }

  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  htmlContent: any;
  isProcessing = true;
  @Input() auditTrail: any = {};

  triggerTrail(data: any) {
    this.grid = [];
    this.getCall();
    this.popupDataTitle.title = this.auditTrail.report_And_Popup_Name;
    this.visibleAuditTrailPopup = this.dialog.open(this.dynAuditTrailPopup, this.auditTrailPopupConfig);
  }

  wvDocumentLoadedHandler(): void {
    const { documentViewer, annotationManager, Annotations } = this.wvInstance.Core;
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';

  ngOnDestroy() {
    this.auditTrail.isTrailFromHomePage = false;
  }

  getCall() {
    this.isProcessing = true;
    const primary_obj = {
      gridName: this.auditTrail.gridName
    }
    this.appService.usergridddynamicFieldsForAudittrails(primary_obj).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const isId: boolean = this.auditTrail.gridName !== 'TRAINING_BADGE' && this.auditTrail.gridName !== 'LOCATION_MASTER' && this.auditTrail.gridName !== 'SCHEDULED_JOBS' && this.auditTrail.gridName !== 'CODELISTS';

        const temp_obj: any = {

          gridName: this.auditTrail.gridName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,

          ...(this.auditTrail.groupId && { au_Trail_groupId: this.auditTrail.groupId }),
          ...(this.auditTrail.activityRefNo && { au_Trail_ActivityRefNo: this.auditTrail.activityRefNo }),
          ...(this.auditTrail.formId_Audit_Trail && { formId_Audit_Trail: this.auditTrail.formId_Audit_Trail == 1 ? 0 : this.auditTrail.formId_Audit_Trail }),
          ...(this.auditTrail.report_Id_Audit_Trail && { report_Id_Audit_Trail: this.auditTrail.report_Id_Audit_Trail }),
          ...(this.auditTrail.productId_Audit_Trail && { productId_Audit_Trail: this.auditTrail.productId_Audit_Trail }),
          ...(this.auditTrail.codelist_Group_Audit_Trail && { codelist_Group_Audit_Trail: this.auditTrail.codelist_Group_Audit_Trail }),
          ...((this.auditTrail.form_SectionId_Audit_Trail || this.auditTrail.form_SectionId_Audit_Trail == 0) && { form_SectionId_Audit_Trail: this.auditTrail.form_SectionId_Audit_Trail }),
          ...(this.auditTrail.form_TemplateId_Audit_Trail && { form_TemplateId_Audit_Trail: this.auditTrail.form_TemplateId_Audit_Trail }),
          ...(this.auditTrail.templateIdFromQmsQuestionnaireTemplate && { templateIdFromQmsQuestionnaireTemplate: this.auditTrail.templateIdFromQmsQuestionnaireTemplate }),
          ...(this.auditTrail.isTrailFromHomePage && { issuedBy: +this.message.getUserId()! }),
          [`auditTrail${isId ? 'Id' : 'Code'}`]: this.auditTrail.refNo?.toString() ?? null,
        }

        const secondary_obj = { ...this.auditTrail.secondary_obj, ...temp_obj };

        this.appService.getDynamicGridData(secondary_obj).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.noData = response1;
            secondary_obj.columnsListarray = secondary_obj.columnsList.split(",");
            secondary_obj.fieldColumnarray = secondary_obj.fieldLabelsList.split(",");
            secondary_obj.invisibleColumnarray = secondary_obj.invisibleColumn.split(",");
            secondary_obj.fieldSizeListArray = secondary_obj.fieldSizeList.split(",");
            this.columnLists.columnsListarray = secondary_obj.columnsListarray;
            this.columnLists.fieldLabelsList = secondary_obj.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < secondary_obj.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": secondary_obj.fieldColumnarray[p],
                "width": secondary_obj.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = secondary_obj.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of secondary_obj.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            this.reportObj = { ...secondary_obj, ...primary_obj };
            /* this.dropDownForReport = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray); */
            this.dropDownForReport = this.columnLists?.fieldColumnarray?.map((item: any) => ({
              valueExp: item.fieldColumnarray,
              displayExp: item.fieldColumnarray
            }));

            let tableData = {
              tablename: secondary_obj.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (let i = 0; i < this.grid.length; i++) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    this.grid[i][element.columnName] = this.grid[i][element.columnName] == "Y" ? true : false;
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter != undefined) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background = keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getCall();
  }

  @ViewChild('dynAuditTrailPopup', { static: true }) dynAuditTrailPopup: TemplateRef<any>;
  visibleAuditTrailPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewerPdfPopup', { static: true }) viewerPdfPopup: TemplateRef<any>;
  visibleViewerPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewerImagePopup', { static: true }) viewerImagePopup: TemplateRef<any>;
  visibleViewerImagePopup: MatDialogRef<TemplateRef<any>>;

  auditTrailPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px', left: '5.8%' },
    maxWidth: '93vw',
  }

  viewerPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 2,
  };

  cancelAuditPopup() {
    this.visibleAuditTrailPopup.close();
  }

  selectedColumns: any;
  dropDownForReport: any;
  isForExcel: boolean = false;
  popupDataTitle: PopupData = { title: '' };
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  openReportPopup(item: any) {
    this.reportFooterDropdown = [];
    this.ngOnChangesReportFooter();
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }

  manuallyPicked: boolean;
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.selectedColumns.length > 30) {
      this.showSnackBar('Selected columns exceeded the limit. Limit 30, Selected ' + this.selectedColumns.length, 'E');
    } else {
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');


      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';

      const fileName = `${this.auditTrail.report_And_Popup_Name.replaceAll(/ /g, '_')}_${formattedDate}.${fileType}`;

      if (value == 'Excel') {

        const excelObj = {
          ...this.reportObj, title: this.auditTrail.report_And_Popup_Name, columns: [],
          "informationTab": { "Report Name": this.auditTrail.report_And_Popup_Name, "Exported By": localStorage.getItem("loggedUserName") }
        }
        this.downloadExcelReport(excelObj, fileName);

      } else {
        const pdfObj = {
          ...this.reportObj, "footer": this.selectedReportFooter, logoId: 0, title: this.auditTrail.report_And_Popup_Name, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.dropDownForReport.map((report: any) => report.valueExp)?.slice(0, 10).join(','), pdfPageSize: this.pdfPageSize
        }
        this.downloadPdfReport(pdfObj, fileName);
      }
    }
  }

  extension: any;
  downloadDocument(list: any) {
    console.log(list);
    let contentData = "data:application/octet-stream;base64," + list.TEMPLATE;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = list.TEMPLATE_NAME + "." + list.TEMPLATE_EXTN;
    downloadLink.click();
  }

  cancelAddAndEditFunction() {
    this.visibleViewerPdfPopup.close();
  }

  cancelAddAndEditFunctionimage() {
    this.visibleViewerPdfPopup.close();
    this.visibleViewerImagePopup.close();
  }
  selectedDocumentName: String;

  downloadDocuments(list: any, columnName: any) {
    if (list.DOWNLOADED_FILE_EXTN != "zip") {
      this.selectedDocumentName = list.DOWNLOADED_FILE_NAME;

      this.visibleViewerPdfPopup = this.dialog.open(this.viewerPdfPopup, this.viewerPopupConfig);
      this.isProcessing = true;
      let docObj = {

        primeIdentifier: list.PRIM_IDENTIFIER,
        tableView: list.tablevwname,
        columnName: columnName
      }

      this.appService.getDocumentToViewAudit(docObj).subscribe((data: any) => {
        console.log(data.headers);
        const header = data.headers.get('content-type');
        console.log(header);
        this.extension = null;
        if (header == 'image/x-png') {
          this.extension = 'png';
        } else if (header == 'application/pdf') {
          this.extension = 'pdf';
        } else if (header == 'text/plain') {
          this.extension = 'txt';
        } else if (header == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          this.extension = 'docx';
        } else if (header == 'application/octet-stream') {
          this.extension = 'xlsx';
        } else if (header == 'image/jpeg') {
          this.extension = 'jpg';
        }

        if (this.extension == 'jpg' || this.extension == 'jpeg' || this.extension == 'png' || this.extension == 'JPG' || this.extension == 'PNG' || this.extension == 'JPEG') {
          this.visibleViewerImagePopup = this.dialog.open(this.viewerImagePopup, this.auditTrailPopupConfig);
          let blob = new Blob([data.body], { type: "image/*" });
          let url = URL.createObjectURL(blob);
          let image: any = document.getElementById("picturewe");
          image.src = url;
        } else {
          this.loadDataInViewer(data, this.extension);
        }
      })
      this.isProcessing = false;
    } else {
      this.isProcessing = true;
      let fileName = list.DOWNLOADED_FILE_NAME;
      fileName = fileName.replaceAll(".", "_");
      this.appService.downloadIssuanceFile(
        list.ISSUANCE_ID, fileName);

      this.isProcessing = false;
    }

  }

  @ViewChild('viewer', { static: false }) viewer: ElementRef;

  wvInstance: any;
  showuploaddiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any) {
    this.showuploaddiv = true;


    if (this.wvInstance != undefined && this.wvInstance.UI && false) {
      if (extn == null) {
        this.wvInstance.UI.loadDocument(data);
      } else {
        this.wvInstance.UI.loadDocument(data.body, { extension: extn });
      }
    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        //  webViewerServer : true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader',
          'printButton',

        ]
      }, this.viewer.nativeElement).then((instance: any) => {
        this.wvInstance = instance;
        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'p') {
              e.preventDefault();
              e.stopPropagation();
              alert('Printing is disabled.');
            } else {
              e.preventDefault();
              e.stopPropagation();
            }
            return false;
          });
        });
        const docViewer = instance.docViewer;
        const annotManager = instance.annotManager;
        // call methods from instance, docViewer and annotManager as needed
        let Feature = instance.Feature;
        instance.UI.setTheme('dark');
        instance.print = false;

        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);

        let FitMode = instance.FitMode;
        if (extn == null) {
          // instance.UI.loadDocument(this.document);
        } else {
          instance.UI.loadDocument(data.body, { extension: extn });
        }

        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {
          console.log("doc loaded");
        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        // now you can access APIs through this.webviewer.getInstance()
        //instance.UI.openElement('notesPanel');
        // see https://docs.apryse.com/documentation/web/guides/ui/apis
        // for the full list of APIs

        instance.Core.documentViewer.addEventListener('documentLoaded', this.wvDocumentLoadedHandler)
      })
    }

  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForReport.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }


  downloadExcelReport(data: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadexcel(data).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        throw error;
      })
  }

  downloadPdfReport(pdfData: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadPdf(pdfData).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        throw error;
      })
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }
  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe(
      (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1);
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].valueExp;
        }

        this.isProcessing = false;
      },
      (error: any) => {
        this.isProcessing = false;
      }
    );
  }


  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {

      if (vals.moduleList == "Common") {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }

    }
  }
}
